import React from 'react';
import { Calendar, CheckCircle2 } from 'lucide-react';

/**
 * Step 4 — Timeline selection (subito / 3m / 6m / oltre 6m).
 */
export function TimelineStep({ config, form, setForm }) {
  return (
    <div className="space-y-4" data-testid="step-timeline">
      <div>
        <div className="flex items-center gap-2 text-[var(--gp-gold)]">
          <Calendar className="w-4 h-4" />
          <span className="text-[10px] tracking-[0.3em] uppercase font-medium">Step 4 / 4</span>
        </div>
        <h3 className="font-serif text-2xl text-[hsl(var(--primary))] mt-1">Quando vorresti procedere?</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
        {config.timelines.map((t) => {
          const sel = form.timeline === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setForm((f) => ({ ...f, timeline: t.id }))}
              className={`p-4 rounded-xl border-2 text-left transition-all ${
                sel
                  ? 'border-[var(--gp-gold)] bg-[var(--gp-gold)]/10 shadow-md'
                  : 'border-border bg-[var(--surface-2)] hover:border-[var(--gp-gold)]/50'
              }`}
              data-testid={`qf-timeline-${t.id}`}
            >
              <div className="font-serif text-lg text-[hsl(var(--primary))]">{t.label}</div>
              <div className="text-xs text-muted-foreground mt-0.5">{t.sub}</div>
              {sel && <CheckCircle2 className="w-4 h-4 text-[var(--gp-gold)] mt-2" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
